import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { GALLERY_NOTE, GARMENTS, OFFER_ANCHOR } from '../../data/collection';
import { primaryButtonClass } from '../../utils/buttonStyles';

/** Grid of 10 models (2 columns on phone/tablet, 3 on desktop). No carousel, no zoom. */
export function GallerySection() {
  return <section id="prendas" aria-labelledby="prendas-title" className="w-full bg-blush" data-id="element-219" data-mp="gyytxr6hizmj">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-8 lg:py-24" data-id="element-220" data-mp="gwm3epmnvgxv">
        <SectionHeading id="prendas-title" title="Descubrí los modelos que podés confeccionar y vender." intro="Vestidos, ranitas, enteritos y conjuntos infantiles para empezar a crear tu propio catálogo. Elegí tus favoritos entre los 31 modelos de la colección." data-id="element-221" data-mp="cvsg9yh1m661" />

        <ul className="mt-10 grid w-full grid-cols-2 gap-x-3 gap-y-7 sm:gap-x-5 sm:gap-y-9 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-12" data-id="element-222" data-mp="22brx81qwkzw8">
          {GARMENTS.map((garment, index) => <li key={garment.image.src} className="min-w-0" data-id="element-223" data-mp="n6fhj6bseou3" data-mpi={index}>
              <figure className="flex w-full min-w-0 flex-col" data-id="element-224" data-mp="r8ka01qi1ff5">
                <div className="overflow-hidden rounded-[14px] bg-paper ring-1 ring-blush-deep sm:rounded-[18px]" data-id="element-225" data-mp="ra511hdlug89">
                  <img src={garment.image.src} alt={garment.image.alt} width={garment.image.width} height={garment.image.height} loading={index < 2 ? 'eager' : 'lazy'} fetchPriority="low" decoding="async" sizes="(min-width: 1024px) 360px, 50vw" className="block aspect-square h-auto w-full object-contain" data-id="element-226" data-mp="dbdtkdt8zst3" />
                </div>
                <figcaption className="mt-3 min-w-0 sm:mt-4" data-id="element-227" data-mp="1ow2eh0d4nvdc">
                  <span className="block break-words font-serif text-[1.05rem] font-semibold leading-snug text-graphite sm:text-[1.3rem] lg:text-[1.4rem]" data-id="element-228" data-mp="1ouho7mxuiyla">
                    {garment.title}
                  </span>
                  <span className="mt-1 block text-[0.88rem] font-semibold text-sage-ink sm:text-[1rem]" data-id="element-229" data-mp="1yk6mbr670x6w">
                    {garment.caption}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>

        <p className="mt-8 max-w-2xl text-[0.92rem] leading-relaxed text-graphite-soft" data-id="element-230" data-mp="1piyotbbi40dv">{GALLERY_NOTE}</p>

        <div className="mt-6" data-id="element-231" data-mp="1klq8lg9wy6f9">
          <a href={OFFER_ANCHOR} className={primaryButtonClass('lg')} data-id="element-232" data-mp="1ftovjs4x8bo6">
            Quiero la colección completa
            <ArrowDownIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-y-0.5" aria-hidden data-id="element-233" data-mp="1au2knpckf7ij" />
          </a>
        </div>
      </div>
    </section>;
}